const isMSD = (organizationName?: string) => (
  organizationName?.toLowerCase() === "msd"
);

export default isMSD;
